var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOfficial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1105.94 375.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:#464646;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1972.62,
    y1: 3449.85,
    x2: 1978.6,
    y2: 3440.46,
    gradientTransform: "matrix(9.13, 0, 0, -22.58, -17772.98, 77970.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30c5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2206.15,
    y1: 3402.7,
    x2: 2212.13,
    y2: 3393.31,
    gradientTransform: "matrix(33.81, 0, 0, -33.4, -74456.15, 113808.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2191.37,
    y1: 3410.37,
    x2: 2197.35,
    y2: 3400.98,
    gradientTransform: "matrix(28.09, 0, 0, -30.17, -61311.5, 103144.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2191.1,
    y1: 3410.77,
    x2: 2197.08,
    y2: 3401.38,
    gradientTransform: "matrix(29.64, 0, 0, -31.83, -64908.03, 108587.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2190.9,
    y1: 3430.75,
    x2: 2196.88,
    y2: 3421.36,
    gradientTransform: "matrix(27.33, 0, 0, -26.51, -59545.48, 90969.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1928.49,
    y1: 3431.03,
    x2: 1934.47,
    y2: 3421.64,
    gradientTransform: "matrix(7.5, 0, 0, -26.5, -13985.12, 90944.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2194.03,
    y1: 3426.57,
    x2: 2200.01,
    y2: 3417.18,
    gradientTransform: "matrix(26.35, 0, 0, -27.56, -57243.01, 94450.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1950.88,
    y1: 3431.03,
    x2: 1956.86,
    y2: 3421.64,
    gradientTransform: "matrix(7.5, 0, 0, -26.5, -13943.14, 90944.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2189.97,
    y1: 3431.41,
    x2: 2195.95,
    y2: 3422.02,
    gradientTransform: "matrix(23.74, 0, 0, -26.5, -51206.47, 90947.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2216.27,
    y1: 3430.6,
    x2: 2222.25,
    y2: 3421.21,
    gradientTransform: "matrix(30.82, 0, 0, -26.5, -67441.95, 90944.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2180.21,
    y1: 3430.47,
    x2: 2186.19,
    y2: 3421.08,
    gradientTransform: "matrix(20.15, 0, 0, -26.5, -42905.75, 90947.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2205.06,
    y1: 3425.37,
    x2: 2211.04,
    y2: 3415.98,
    gradientTransform: "matrix(30.82, 0, 0, -26.5, -67525.94, 90979.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 2198.58,
    y1: 3425.52,
    x2: 2204.56,
    y2: 3416.13,
    gradientTransform: "matrix(27.33, 0, 0, -26.51, -59492.97, 91003.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2214.14,
    y1: 3425.8,
    x2: 2220.12,
    y2: 3416.41,
    gradientTransform: "matrix(30.82, 0, 0, -26.5, -67458.85, 90979.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1976.02,
    y1: 3425.8,
    x2: 1982,
    y2: 3416.41,
    gradientTransform: "matrix(7.5, 0, 0, -26.5, -13896, 90979.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2203.58,
    y1: 3425.8,
    x2: 2209.56,
    y2: 3416.41,
    gradientTransform: "matrix(25.22, 0, 0, -26.5, -54549.54, 90979.28)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67-2",
    "data-name": "Group 67-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65-41",
    "data-name": "Group 65-41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39-41",
    "data-name": "Group 39-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33-41",
    "data-name": "Path 33-41",
    className: "cls-1",
    d: "M260.71,191.62V78.74H215.07v52.94C228.9,142.2,247.86,168.62,260.71,191.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-41",
    "data-name": "Path 34-41",
    className: "cls-2",
    d: "M223.79,158.1h0a79.15,79.15,0,0,0-20.27-15.71c-7.91-4.77-26.39-8.4-38.6-8.4a72.08,72.08,0,0,0-27.62,5.41A65.94,65.94,0,0,0,114,155.46a81.43,81.43,0,0,0-16.22,26.13,95.57,95.57,0,0,0-6.15,35.58v.6a95.61,95.61,0,0,0,6.15,35.58,80,80,0,0,0,16.37,26.13,67.41,67.41,0,0,0,23.42,16.06A71.53,71.53,0,0,0,164.92,301a56.26,56.26,0,0,0,29.88-7.3A72.17,72.17,0,0,0,215.07,275,22.92,22.92,0,0,0,238,298h22.7V278.17c0-43-6.25-84.65-34.39-117.2C225.48,160,224.64,159.05,223.79,158.1Zm-8.1,59.67a51.15,51.15,0,0,1-3.16,18.29,45.49,45.49,0,0,1-8.4,14.21,37.25,37.25,0,0,1-42.64,9.07A37.81,37.81,0,0,1,149,250.27a43.64,43.64,0,0,1-8.56-14.21,51.15,51.15,0,0,1-3.16-18.29v-.6a50.63,50.63,0,0,1,3.16-18.44A43.77,43.77,0,0,1,149,184.67a37.67,37.67,0,0,1,12.46-9.07,36.76,36.76,0,0,1,42.64,9.07,45.49,45.49,0,0,1,8.4,14.21,51.15,51.15,0,0,1,3.16,18.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-165",
    "data-name": "Path 35-165",
    className: "cls-3",
    d: "M311,224.92V332H214.32v43.83H354.79V224.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-166",
    "data-name": "Path 35-166",
    className: "cls-4",
    d: "M46.22,159.15V120.69a74.48,74.48,0,0,1,74.47-74.47h27.52V0H120.69A120.81,120.81,0,0,0,0,120.68v38.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68-2",
    "data-name": "Group 68-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36-2",
    "data-name": "Group 36-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8-2",
    className: "cls-5",
    d: "M311.92,3.25h62.66a87.66,87.66,0,0,1,38.61,8.14,61.27,61.27,0,0,1,26.12,23.09,70.73,70.73,0,0,1,0,70,61.34,61.34,0,0,1-26.12,23.09,87.66,87.66,0,0,1-38.61,8.14H311.92Zm61.14,102.59a38.47,38.47,0,0,0,27.36-9.65,39.69,39.69,0,0,0,0-53.38,38.43,38.43,0,0,0-27.36-9.65H349.4v72.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9-2",
    "data-name": "Path 9-2",
    className: "cls-6",
    d: "M468.27,3.25h37.5v132.5h-37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10-2",
    "data-name": "Path 10-2",
    className: "cls-7",
    d: "M621.22,66.66h33.12v54.9a86.57,86.57,0,0,1-26.12,12.5,104,104,0,0,1-29.53,4.35,79,79,0,0,1-37.5-8.8,65.67,65.67,0,0,1-26.12-24.5,71.63,71.63,0,0,1,0-71.17,65.31,65.31,0,0,1,26.32-24.5,80.79,80.79,0,0,1,38-8.8,84.75,84.75,0,0,1,33.32,6.24,64.27,64.27,0,0,1,24.6,18L633.5,46.46A42,42,0,0,0,601.32,31.7a35.63,35.63,0,0,0-37.86,37.86,40.06,40.06,0,0,0,4.73,19.59,34,34,0,0,0,13.25,13.44,38.85,38.85,0,0,0,19.5,4.82,47.86,47.86,0,0,0,20.26-4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11-2",
    "data-name": "Path 11-2",
    className: "cls-8",
    d: "M678.2,3.25h37.5v132.5H678.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12-2",
    "data-name": "Path 12-2",
    className: "cls-9",
    d: "M770.57,33h-40.7V3.25H848.56V33h-40.5V135.75h-37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13-2",
    "data-name": "Path 13-2",
    className: "cls-10",
    d: "M944.72,110h-56l-10.41,25.74H840l58.5-132.5h36.92l58.68,132.5h-39Zm-11-27.64-17-42.4-17,42.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14-2",
    "data-name": "Path 14-2",
    className: "cls-11",
    d: "M1004.72,3.25h37.5V106h63.22v29.72H1004.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15-2",
    "data-name": "Path 15-2",
    className: "cls-12",
    d: "M512.86,283.15h-56l-10.41,25.74H408.19l58.5-132.5H503.6l58.68,132.5h-39Zm-11-27.64-17-42.42-17,42.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16-2",
    "data-name": "Path 16-2",
    className: "cls-13",
    d: "M574.45,176.39H637.1a87.56,87.56,0,0,1,38.62,8.14,61.33,61.33,0,0,1,26.12,23.09,70.78,70.78,0,0,1,0,70,61.39,61.39,0,0,1-26.12,23.09,87.84,87.84,0,0,1-38.62,8.14H574.45ZM635.59,279a38.39,38.39,0,0,0,27.35-9.65,39.67,39.67,0,0,0,0-53.38,38.41,38.41,0,0,0-27.35-9.66H611.93V279Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    "data-name": "Path 17-2",
    className: "cls-14",
    d: "M852,308.89l-.38-70.22-34.07,57.16H800.93L767,240.56v68.33H732.4V176.39h30.86l46.56,76.48,45.43-76.48h30.86l.38,132.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18-2",
    "data-name": "Path 18-2",
    className: "cls-15",
    d: "M913.88,176.39h37.5v132.5h-37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19-2",
    "data-name": "Path 19-2",
    className: "cls-16",
    d: "M1105.37,176.39v132.5h-30.86L1016,238.28v70.61H979.29V176.39h30.86l58.5,70.6v-70.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37-2",
    "data-name": "Group 37-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20-2",
    "data-name": "Path 20-2",
    className: "cls-17",
    d: "M410.4,342.44h25.1v6.31h-8.77v23h-7.65v-23H410.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21-2",
    "data-name": "Path 21-2",
    className: "cls-17",
    d: "M472.43,364.08a5.56,5.56,0,0,0,4.14,1.67,5.21,5.21,0,0,0,4-1.65,6.34,6.34,0,0,0,1.5-4.45V342.44h7.64v17.21a13.34,13.34,0,0,1-1.61,6.66,11,11,0,0,1-4.59,4.41,15,15,0,0,1-7,1.54,15.43,15.43,0,0,1-7-1.54,11.12,11.12,0,0,1-4.68-4.41,12.94,12.94,0,0,1-1.65-6.66V342.44h7.64v17.21A6.12,6.12,0,0,0,472.43,364.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22-2",
    "data-name": "Path 22-2",
    className: "cls-17",
    d: "M537.6,371.72l-4.26-8.1h-5.68v8.1H520V342.44h13.16a13.52,13.52,0,0,1,9,2.69,9.38,9.38,0,0,1,3.2,7.59,11.57,11.57,0,0,1-1.34,5.7,9.35,9.35,0,0,1-3.89,3.74l6.1,9.56Zm-9.94-14.2h5.55a5.23,5.23,0,0,0,3.62-1.17A4.42,4.42,0,0,0,538.1,353a4.17,4.17,0,0,0-1.27-3.27,5.17,5.17,0,0,0-3.62-1.15h-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23-2",
    "data-name": "Path 23-2",
    className: "cls-17",
    d: "M595.33,342.44h7.1v29.28h-6.68l-13.29-17.5v17.5h-7.14V342.44h6.73l13.33,17.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24-2",
    "data-name": "Path 24-2",
    className: "cls-17",
    d: "M667.56,342.44h7.64v29.28h-7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25-2",
    "data-name": "Path 25-2",
    className: "cls-17",
    d: "M703.38,342.44h25.11v6.31h-8.77v23h-7.65v-23h-8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26-2",
    "data-name": "Path 26-2",
    className: "cls-17",
    d: "M811.74,344.28a13.41,13.41,0,0,1,5.5,5.16,15.76,15.76,0,0,1,0,15.27,13.45,13.45,0,0,1-5.6,5.18,18.17,18.17,0,0,1-8.29,1.84H791V342.44h12.62A17.12,17.12,0,0,1,811.74,344.28Zm-4,20.22a7.18,7.18,0,0,0,2.68-3,9.92,9.92,0,0,0,1-4.38,9.31,9.31,0,0,0-1-4.43,7.54,7.54,0,0,0-2.82-3,7.87,7.87,0,0,0-4.1-1.06h-4.8v16.87h5.18a7.37,7.37,0,0,0,3.91-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27-2",
    "data-name": "Path 27-2",
    className: "cls-17",
    d: "M848.07,342.44h7.63v29.28h-7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28-2",
    "data-name": "Path 28-2",
    className: "cls-17",
    d: "M905.84,356.77h6.6v11.65a19.81,19.81,0,0,1-5.74,2.78,21.86,21.86,0,0,1-6.46,1.07,16.32,16.32,0,0,1-8-2A14.83,14.83,0,0,1,884.57,357a14.52,14.52,0,0,1,2.11-7.7,14.76,14.76,0,0,1,5.81-5.41,17.28,17.28,0,0,1,8.25-2,18.74,18.74,0,0,1,6.5,1.19,17,17,0,0,1,5.5,3.2l-4.35,5.34a12.23,12.23,0,0,0-3.65-2.38,10.45,10.45,0,0,0-4.08-.87,8,8,0,0,0-7.18,4.22,8.82,8.82,0,0,0-1.09,4.38,9.11,9.11,0,0,0,1.09,4.45,7.94,7.94,0,0,0,3,3.11,8.16,8.16,0,0,0,4.25,1.13,11.47,11.47,0,0,0,5.06-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29-2",
    "data-name": "Path 29-2",
    className: "cls-17",
    d: "M942.56,342.44h7.64v29.28h-7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30-2",
    "data-name": "Path 30-2",
    className: "cls-17",
    d: "M978.4,342.44h25.1v6.31h-8.77v23h-7.65v-23H978.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31-2",
    "data-name": "Path 31-2",
    className: "cls-17",
    d: "M1050,371.72l-2-5.18h-12.66l-2,5.18h-7.86l12.58-29.28h7.85l12.28,29.28Zm-12.37-11h8.11l-4-10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32-2",
    "data-name": "Path 32-2",
    className: "cls-17",
    d: "M1085.88,342.44h7.65V365.2h12.41v6.5h-20.06Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfficial);
export default __webpack_public_path__ + "static/media/logo-official.36e76daec35d61821377cc2a9f3f68fe.svg";
export { ForwardRef as ReactComponent };